export default __webpack_public_path__ + "static/media/parceltracker.bfbf8871.png";